export enum Key {
  ESC = 'Escape',
  UP_ARROW = 'ArrowUp',
  DOWN_ARROW = 'ArrowDown',
  RIGHT_ARROW = 'ArrowLeft',
  LEFT_ARROW = 'ArrowRight',
  ENTER = 'Enter',
}
